/**
 * @file getSubQuestionId.ts
 * Exports a method for returning the IDs of answers with true values.
 */
import { AppState } from '../types';

/**
 * Helper method that returns an object of sub question with id.
 *
 * Currently all questions are organized in a JSON file. In the future this data
 * may come from an external API.
 *
 * @returns {object}
 *   An object of sub question return with id
 * @param {AppState} appState
 *   The state object shared across the application.
 *
 */

export default (appState: AppState) => {
  const {
    appData: { subQueId },
  } = appState;
  return subQueId;
};
